export const baseUrl = process.env.REACT_APP_BASE_URL;
export const noticeBaseUrl = process.env.REACT_APP_BASE_URL_NOTICE;
export const happeningBaseUrl = process.env.REACT_APP_BASE_URL_HAPPENINGS;
